export default __webpack_public_path__ + "static/media/counters-img.d4dcdc63.svg";